import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18a8c08b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "our-solutions" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "top-line" }, [
  /*#__PURE__*/_createElementVNode("h1", { class: "title" }, [
    /*#__PURE__*/_createTextVNode("Become "),
    /*#__PURE__*/_createElementVNode("span", { class: "color" }, "#1 Bookmaker!")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "title-text" }, " Upgrade your betting shops, start online and launch within days, we will meet your needs! ")
], -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item animate" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon online" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Online Solution"),
  /*#__PURE__*/_createElementVNode("p", null, " Market-leading features help drive customer engagement and retention to maximize revenue generation. ")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item animate" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon retail" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Retail Solution"),
  /*#__PURE__*/_createElementVNode("p", null, " A world-class, reliable and high-volume transaction solution enabling tellers to provide a simple controlled user experience. ")
], -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-item animate" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "icon label" }),
  /*#__PURE__*/_createElementVNode("h3", null, "Full White Label Solution"),
  /*#__PURE__*/_createElementVNode("p", null, " Cost-effective, comprehensive solution aimed at launching your own betting shop in the shortest time possible. ")
], -1))
const _hoisted_8 = { class: "show-more" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SliderTop = _resolveComponent("SliderTop")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createVNode(_component_SliderTop, { class: "list" }, {
        default: _withCtx(() => [
          _hoisted_5,
          _hoisted_6,
          _hoisted_7
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_8, [
        _createVNode(_component_router_link, {
          class: "btn",
          to: "/solutions"
        }, {
          default: _withCtx(() => [
            _createTextVNode(" See all benefits ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}